// Components/Services/HOACommercial/FullHOAPage.jsx
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import WhoItsFor from "./WhoItsFor";
import ProcessSection from "./ProcessSection";
import WhoWeAre from "../AboutUs/WhoWeAre";
import FinalCTA from "../HomePage/FinalCTA";
import HOACommercialOverview from "./HOACommercialOverview";
import Overview from "../ADU&newcustomhome/OverView";
import HomeRemodelOverview from "../FullHomeRemodel/HomeRemodelOverview";
import TakeoverProjectsOverview from "../TakeoverProjects/TakeoverProjectsOverview";
import HomeRemodelPortfolio from "../FullHomeRemodel/HomeRemodelPortfolio";
import ADUPortfolio from "../ADU&newcustomhome/ADUPortfolio";
import HOAOtherServices from "./HOAOtherServices";
import HOAPortfolio from "./HOAPortfolio";

export default function FullHOAPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>HOA & Commercial Projects | Ashlar Building Group</title>
        <meta
          name="description"
          content="Ashlar Building Group manages HOA building envelope rehabilitation, waterproofing, balcony repair, and light commercial tenant improvements across California. Licensed, bonded, and built for large-scale projects."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.ashlarbuildinggroup.com/services/hoa-commercial" />

        {/* Open Graph */}
        <meta property="og:title" content="HOA & Commercial Projects | Ashlar Building Group" />
        <meta
          property="og:description"
          content="From HOA building envelope rehabilitation to light commercial tenant improvements — Ashlar delivers complex, high-value projects with full accountability."
        />
        <meta property="og:image" content="/Images/ADUs.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.ashlarbuildinggroup.com/services/hoa-commercial" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="HOA & Commercial Projects | Ashlar Building Group" />
        <meta
          name="twitter:description"
          content="Licensed California general contractor for HOA reconstruction, building envelope work, and commercial tenant improvements."
        />
        <meta name="twitter:image" content="/Images/ADUs.png" />

        {/* Schema */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "HomeAndConstructionBusiness",
            "name": "Ashlar Building Group",
            "url": "https://www.ashlarbuildinggroup.com",
            "logo": "https://www.ashlarbuildinggroup.com/Images/logo.png",
            "description": "California general contractor specializing in HOA building envelope rehabilitation, waterproofing, and light commercial tenant improvements.",
            "telephone": "+19256557741",
            "email": "info@ashlarbuilding.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "6200 Stoneridge Mall Rd",
              "addressLocality": "Pleasanton",
              "addressRegion": "CA",
              "postalCode": "94588",
              "addressCountry": "US"
            },
            "areaServed": ["Bay Area", "Orange County", "Los Angeles", "San Diego"],
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "HOA & Commercial Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Building Envelope Rehabilitation",
                    "description": "Waterproofing, exterior cladding, balcony and deck repair for HOA communities."
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Common Area Reconstruction",
                    "description": "Clubhouses, lobbies, walkways, and shared spaces rebuilt to HOA specifications."
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Commercial Tenant Improvements",
                    "description": "Office build-outs, retail renovations, and commercial interior improvements."
                  }
                }
              ]
            }
          }
        `}</script>
      </Helmet>

      <HeroSection />
    <HOACommercialOverview/>
    <HOAPortfolio/>
      <WhoItsFor />
      <ProcessSection />
      <HOAOtherServices/>
     <Overview/>
     <ADUPortfolio/>
     <HomeRemodelOverview/>
     <HomeRemodelPortfolio/>    
     <TakeoverProjectsOverview/>
      <WhoWeAre />
      <FinalCTA />
    </>
  );
}